import React from 'react'

import { IPageDetailsType } from '@/types'

export const HeroSection: React.FC<IPageDetailsType> = ({ title }) => {
  return (
    <section className="theme--dark-blue white-color padding-vertical-regular">
      <div className="row">
        <div className="column small-12">
          <h1>{title}</h1>
        </div>
      </div>
    </section>
  )
}
